import { StyleSheet } from 'react-native';
import { RESIDENTS_MOBILE_COLORS } from '@/constants/residents/mobile/color';

/**
 * Shared styles for mobile payment screens
 * Reduces duplication across payment-related screens
 */
export const mobileScreenStyles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: RESIDENTS_MOBILE_COLORS.BACKGROUND_PRIMARY,
  },
  content: {
    flex: 1,
  },
  contentContainer: {
    padding: 16,
  },
  sectionDescription: {
    fontSize: 14,
    color: RESIDENTS_MOBILE_COLORS.TEXT_TERTIARY,
    marginBottom: 16,
  },
  sectionTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: RESIDENTS_MOBILE_COLORS.TEXT_PRIMARY,
    marginTop: 8,
    marginBottom: 12,
  },
  loadingContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 80,
  },
  emptyState: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 80,
    paddingHorizontal: 32,
  },
  emptyIconContainer: {
    marginBottom: 24,
  },
  emptyTitle: {
    fontSize: 18,
    fontWeight: '600',
    color: RESIDENTS_MOBILE_COLORS.TEXT_PRIMARY,
    marginBottom: 8,
    textAlign: 'center',
  },
  emptyMessage: {
    fontSize: 14,
    color: RESIDENTS_MOBILE_COLORS.TEXT_TERTIARY,
    textAlign: 'center',
    lineHeight: 20,
    marginBottom: 24,
  },
  cardWrapper: {
    marginBottom: 12,
  },
});

